module.exports = __webpack_public_path__ + "static/media/jrnl-logo_full-light.b60d0c84.svg";